import { Stack, Typography } from "@mui/material";

const GuidelineStep = ({ title, children = null, id = title }) => {
  return (
    <Stack direction="column" spacing={1} id={id}>
      <Typography variant={"h5"}>{title}</Typography>
      {children}
    </Stack>
  );
};

export default GuidelineStep;
